// src/pages/LogoutPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';






function LogoutButton({ positionStyle = {} }) {
  const navigate = useNavigate();
  const handleLogout = async () => {

    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    console.log('localstorage cleared')
            // 2. Clear the default Axios Authorization header
    delete axios.defaults.headers.common['Authorization'];

      navigate('/signin'); // Or your actual login route
    
  };

  return (
    <div style={positionStyle}>
      <button 
        className="journey-button"
        title="Logout"
        onClick={handleLogout}
      >
        ⬅ Logout
      </button>
    </div>
  );
}

export default LogoutButton;
